import { render, staticRenderFns } from "./ModalStoryWriter.vue?vue&type=template&id=3b67e208&scoped=true"
import script from "./ModalStoryWriter.vue?vue&type=script&lang=js"
export * from "./ModalStoryWriter.vue?vue&type=script&lang=js"
import style0 from "./ModalStoryWriter.vue?vue&type=style&index=0&id=3b67e208&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67e208",
  null
  
)

export default component.exports